module.exports = __webpack_public_path__ + "img/pet_glasses_2.459e74f2.svg";